export default {
	default: [''],
	nested: ['table--nested']
};
